"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
var exceptions_1 = require("../exceptions");
function defaultTargetElement(x, y) {
    var document = window.document;
    return document.elementFromPoint(x, y);
}
function defaultShowAction(targetElement, x, y, key) {
    var document = window.document;
    var body = document.body;
    var typeSignal = document.createElement("div");
    typeSignal.style.zIndex = "2000";
    typeSignal.style.border = "3px solid orange";
    typeSignal.style.borderRadius = "50%";
    typeSignal.style.width = "40px";
    typeSignal.style.height = "40px";
    typeSignal.style.boxSizing = "border-box";
    typeSignal.style.position = "absolute";
    typeSignal.style.transition = "opacity 1s ease-out";
    typeSignal.style.left = x + "px";
    typeSignal.style.top = y + "px";
    typeSignal.style.textAlign = "center";
    typeSignal.style.paddingTop = "7px";
    typeSignal.innerHTML = String.fromCharCode(key);
    var element = body.appendChild(typeSignal);
    setTimeout(function () { return body.removeChild(element); }, 1000);
    setTimeout(function () { return (element.style.opacity = "0"); }, 50);
}
function typer() {
    var document = window.document;
    var documentElement = document.documentElement;
    var defaultEventTypes = ["keypress", "keyup", "keydown"];
    function defaultKeyGenerator() {
        if (config.randomizer === null) {
            return 3;
        }
        return config.randomizer.natural({ min: 3, max: 254 });
    }
    var config = {
        eventTypes: defaultEventTypes,
        showAction: defaultShowAction,
        keyGenerator: defaultKeyGenerator,
        targetElement: defaultTargetElement,
        logger: console,
        randomizer: null
    };
    function typerGremlin() {
        if (!config.randomizer) {
            throw new exceptions_1.RandomizerRequiredException();
        }
        var keyboardEvent = document.createEvent("Events");
        var eventType = config.randomizer.pick(config.eventTypes);
        var key = config.keyGenerator();
        var posX = config.randomizer.natural({
            max: documentElement.clientWidth - 1
        });
        var posY = config.randomizer.natural({
            max: documentElement.clientHeight - 1
        });
        var targetElement = config.targetElement(posX, posY);
        if (!targetElement) {
            throw new Error("No element found at " + posX + "x" + posY);
        }
        keyboardEvent.initEvent(eventType, true, true);
        keyboardEvent.keyCode = key;
        keyboardEvent.which = key;
        keyboardEvent.keyCodeVal = key;
        targetElement.dispatchEvent(keyboardEvent);
        if (typeof config.showAction === "function") {
            config.showAction(targetElement, posX, posY, key);
        }
        if (config.logger && typeof config.logger.log === "function") {
            config.logger.log("gremlin", "typer       type", String.fromCharCode(key), "at", posX, posY);
        }
    }
    utils_1.configurable(typerGremlin, config);
    return typerGremlin;
}
exports.typer = typer;
